<template>
    <el-dialog v-dialogDrag class="dialog" width="600px"
               :visible.sync="dialogVisible"
               append-to-body
               @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                账套选择
            </div>
        </div>
        <div class="dialog_body">
            <el-table
                    ref="treeTable"
                    :data="dataList"
                    height="300"
                    style="width: 100%;"
                    highlight-current-row
                    :header-cell-style="headerStyle"
                    :cell-style="cellStyle"
                    row-key="id"
                    border>
                <el-table-column
                        type="index"
                        width="50">
                </el-table-column>
                <el-table-column
                        type="selection"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="accountName"
                        label="账套名称"
                        width="300">
                </el-table-column>
            </el-table>
            <div style="text-align: center;padding: 10px 0px 20px 0px">
                <el-button type="danger" @click="close">取 消</el-button>
                <el-button type="primary" @click="submitForm">保 存</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "selRole",
        props: ['formData', 'loading'],
        data() {
            return {
                dialogVisible: true,
                dialoading: false,
                dataList: [],
            }
        },
        async created() {
            await this.getListData();

            this.defaultSelect();
        },
        methods: {
            submitForm() {
                let rows = this.$refs.treeTable.selection;
                if(rows.length>0){
                    let accountIds = [];
                    let accountNames = [];
                    rows.map(item=>{
                        accountIds.push(item.accountId)
                        accountNames.push(item.accountName)
                    })
                    this.formData.accountIds = accountIds.toString();
                    this.formData.accountNames = accountNames.toString();
                    this.$emit("checkRow");
                }else{
                    this.$message({message: '请选择一个可登录账套', type: 'error'});
                }
            },
            headerStyle() {
                return "text-align:center;height:45px;line-hight:45px;padding: 1px 0;background-color:#f2f2f2;border-left:1px solid #e5e6e8;border-top:1px solid #e5e6e8;border-bottom:1px solid #e5e6e8"
            },
            cellStyle() {
                return "text-align:center"
            },
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            async getListData() {
                this.dialoading = true;
                let param = {
                    url: "/account/listSel",
                    param: {
                        pageSize: "999",
                        currentPage: "1"
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param);
                if (data.infoCode == '0') {
                    this.dataList = data.data.data;
                }
                this.dialoading = false;
            },
            //默认选中
            defaultSelect() {
                this.$nextTick(() => {
                    if(this.formData.accountIds){
                        let accounts = this.formData.accountIds.split(",");
                        accounts.map(account => {
                            let selrow = this.dataList.find(item => {
                                return item.accountId === account
                            })
                            if (selrow)
                                this.$refs.treeTable.toggleRowSelection(selrow);
                        })
                    }
                });
            },

        },
    }
</script>

